import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dfb0e85"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("创建询证记录")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("生成报表数据")
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import { ref, reactive, computed} from 'vue'
import eptBtn from '@/components/ExportButton.vue'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { getNumber, formatNumber } from '@/utils/index'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import orderList from '@/views/ViewsComponents/financialReceivable/OrderList.vue'
import invoiceList from '@/views/ViewsComponents/financialReceivable/InvoiceList.vue'
import flowList from '@/views/ViewsComponents/financialReceivable/FlowList.vue'
import { useRouter } from 'vue-router'
import Api from '@/http/modules/index'
import { ElMessage, ElMessageBox } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { 
  'POST/order/receivable/annual_statistics': fetchList,
  // 获取所有公司
  'GET/company': companyApi,
  // 导出应收账款年度统计
  'POST/order/receivable/annual_statistics/export': annual_statisticsExportApi,
  // 导入应收账款
  'POST/order/receivable/clients/country/batch_update': batch_updateApi,
  // 创建询证记录
  'POST/confirmation/create': createApi,
  // 应收账款公司币种汇总
  'POST/order/receivable/annual_statistics/summary': exportReportApi,

} = Api
const router = useRouter()
let selectionRows = ref([])

dayjs.extend(quarterOfYear)
let columnsDays = ref<{label?: string, subTitle?: string, subLabel: string}[]>([])
const searchObj = reactive({
  companyAlias: '',
  type: 'year',
  month: [dayjs().startOf('year').format('YYYY-MM-DD'),dayjs().endOf('year').format('YYYY-MM-DD')],
  customerName: '',
  customerUsername: '',
  email: '',
  update: '',
  showZeroAmount: false,
  showClientMultiple: false,
})

const adjustRef = ref()
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_height
} = new tbMix(fetchList)
size.value = 200

const companyAliasMap: any = {
  'CCJK Technologies Co., Ltd.': '深圳市昆仲科技有限公司',
  'CCJK CO.,Ltd.': 'CCJK CO LIMITED',
  'CCJK Localization Pte Ltd.': 'CCJK LOCALIZATION PTE LTD',
  'Mars Translation CO.,Ltd.': '深圳市比邻火星翻译有限公司',
  'Hunan Artlangs Translation Services Co.,Ltd.': '湖南雅言翻译服务有限公司',
  'Shenzhen Sodoglobal CO.,Ltd.': '深圳市多语新媒体科技有限公司',
  'Wuhan Transee Translation Co., Ltd.': '武汉传禧文化有限公司',
  'WetransTech Media Solutions Co.,Ltd.': '长沙维译数字科技有限公司',
  'MarsCrowd CO.,Ltd.': '深圳市火星众包科技有限公司',
  'LocalizationLine Solutions Co.,Ltd.': '南昌顺飞数字翻译有限公司',
  'Changsha BiAn language services co.,ltd': '长沙彼岸信息科技有限公司',
  'Marshub Co.,Ltd.': '火星语盟（深圳）科技有限公司',
  'Changsha Beyond Cloud Translation Co.,Ltd.': '长沙彼岸译云医学科技有限公司',
  'Wordspath Information Co.,Ltd.': '佛山市得译信息科技有限公司' ,
  'MarsHub(Hunan) Co., Ltd': '火星语盟（湖南）科技有限公司',
  '火星语盟（湖南）科技有限公司': '火星语盟（湖南）科技有限公司',
  'Mars Translation HK CO.,Ltd.': 'MARS TRANSLATION HK CO LTD',

}

const searchHandle = async () => {

  await fetchData({
    dateRange: {
      from: searchObj.month[0],
      to: searchObj.month[1],
    },
    dateType: searchObj.type,
    companyAlias: searchObj.companyAlias,
    companyName: companyAliasMap[searchObj.companyAlias],
    client: searchObj.customerUsername,
    customerName: searchObj.customerName,
    email: searchObj.email,
    update: searchObj.update,
    showClientMultiple: searchObj.showClientMultiple,
    showZeroAmount: searchObj.showZeroAmount,
  }, {timeout: 120000})




  // 没有选择时间范围
  if(searchObj.month.length === 0) return;
  columnsDays.value = []

  // 如果不按季度展示
  if(searchObj.type !== 'quarter'){
    let range = Math.abs(dayjs(searchObj.month[0]).diff(searchObj.month[1], searchObj.type as any)) + 1
    // 循环获取期间月份/年份
    for (let index = 0; index < range; index++) {
      let subLabel = dayjs(searchObj.month[0]).add(index, searchObj.type as any).endOf(MI_params.dateType).format('YYYY-MM-DD')
      columnsDays.value.push({ 
        label: dayjs(searchObj.month[0]).add(index, searchObj.type as any).format(MI_params.dateType === 'year' ? 'YYYY' : 'YYYY-MM'),
        subLabel,
        // preDate: dayjs(searchObj.month[0]).add(index - 1, searchObj.type as any).format(formatType[searchObj.type]),
        subTitle: index + 1 === range ? dayjs(searchObj.month[1]).endOf('month').format('YYYY-MM-DD') : subLabel
      })
    }
    return
  }
  // 按照季度显示,先获取完整月份arr
  // 根据月份获取季度后去重
  let range2 = Math.abs(dayjs(searchObj.month[0]).diff(searchObj.month[1], 'month')) + 1
  for (let index = 0; index < range2; index++) {
    columnsDays.value.push({ 
      label: dayjs(searchObj.month[0]).add(index, 'month').format('YYYY-MM')
    } as any)
  }
  columnsDays.value = columnsDays.value.reduce((arr: any, month: any , index: number) => {
    if(arr.find((quarter: any) => (dayjs(quarter.subLabel).quarter() === dayjs(month.label).quarter()) && 
      dayjs(quarter.subLabel).format('YYYY') === dayjs(month.label).format('YYYY')) ) return arr;
    
    let subLabel = dayjs(month.label).endOf('quarter').format('YYYY-MM-DD')
    arr.push({
      label: `${dayjs(month.label).format('YYYY')}年${dayjs(month.label).quarter()}季度`,
      subLabel,
      subTitle: index + 3 >= range2 ? dayjs(searchObj.month[1]).endOf('month').format('YYYY-MM-DD') : subLabel
    })
    return arr
  }, []) as any
  // let range2 = dayjs(searchObj.month[1]).diff(searchObj.month[1], 'quarter') + 1
  
}

const sizeChange = (number: number) => {
  size.value = number
  searchHandle()
  
}
// 展示(增加)订单详情
const orderFg = ref<boolean>(false)
let orderParams = reactive({})
const showOrderList = (row: any, time: any, idsTypeStr: string) => {
  let obj = row['years'].find((e: any) => e.subLabel === time.subLabel)
  // Object.assign(orderParams, {ids: obj[idsTypeStr]})
  // orderFg.value = true
  if(!obj[idsTypeStr] || (obj[idsTypeStr] && obj[idsTypeStr].length === 0)){
    return
  }
  router.push({ path: '/order-query', 
    query: {
      ids: obj[idsTypeStr]
    } 
  })
}
// 跳转发票
const invoiceFg = ref<boolean>(false)
let invoiceParams = reactive({})
const showInvoiceList = (row: any, time: any) => {
  // let obj = row['years'].find((e: any) => e.subLabel === time.subLabel)
  // Object.assign(invoiceParams, {ids: obj.invoiceIds})
  // invoiceFg.value = true
  // 跳转发票页面
  let obj = row['years'].find((e: any) => e.subLabel === time.subLabel)
  if(!obj.invoiceIds || (obj.invoiceIds && obj.invoiceIds.length === 0)){
    return
  }
  router.push({ path: '/invoice', 
    query: {
      ids: obj.invoiceIds,
    } 
  })
  // 
}

// 收款跳转
const FlowFg = ref<boolean>(false)
let FlowParams = reactive({})
const showFlowList = (row: any, time: any) => {
  let obj = row['years'].find((e: any) => e.subLabel === time.subLabel)
  if(!obj.paymentIds  || (obj.paymentIds && obj.paymentIds.length === 0)){
    return
  }
  router.push({ 
    path: '/order-query', 
    query: {
      ids: obj.paymentIds
    } 
  })
  
  // Object.assign(FlowParams, {ids: obj.paymentIds})
  // FlowFg.value = true
}

// -----------------
let previousTime = computed(() => {
  if(columnsDays.value.length === 0){
    return {
      label: ''
    }
  }
  return {
    label: dayjs(columnsDays.value[0].subLabel).subtract(1, MI_params.dateType).endOf(MI_params.dateType as any).format('YYYY-MM-DD') 
  }
})

// 是否展示余额为0的客户
let isShowZero = ref<boolean>(false)
let tableData = computed(() => {
  let tableArr = MI_tableData.value.reduce((arr: any,  _row: any) => {

    let yearsArr: any = columnsDays.value.map((_date: any, index: number, originArr) => {
      let obj = _row.years[_date.subLabel]
      if(index === 0 && !obj){
        _date._lastVal = _row.initAmount
        return {
          ..._date,
          lastVal: '0',
        }
      }
      if(index === 0){
        _date._lastVal = _row.initAmount + (obj.orderAmount) - (obj.paymentAmount)
        return {
          ..._date,
          ...obj
        }
      }
      if(!obj){
        _date._lastVal = originArr[index - 1]._lastVal
        return {
          ..._date,
          lastVal: '0',
        }
      }
      _date._lastVal =  originArr[index - 1]._lastVal + (obj.orderAmount) - (obj.paymentAmount)
      return {
        ..._date,
        ...obj
      }
    })
    
    if(isShowZero.value === true && yearsArr.length && yearsArr[yearsArr.length - 1]['_lastVal'] == 0){
      return arr
    }

    arr.push({
      ..._row,
      years: yearsArr
    })
    return arr
  }, [])


  return tableArr
})

const hiddenZeroHandle = () => {
  isShowZero.value = !isShowZero.value
}

const formatDataAmount = (row: any, _time: any, column: any) =>{

  // let _obj = row['years'][dayjs(_time.subLabel).format(formatType[MI_params.dateType])]
  let _obj = row['years'].find((time: any) => time.subLabel == _time.subLabel ) 
  // return _obj ? getNumber(_obj[column.property]) : ''
  return (_obj && _obj[column.property] && _obj[column.property].toLocaleString()) || '-'
}

// 创建征询记录
const createConfirmationHandle = () => {
  if(selectionRows.value.length < 1){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  // 输入期次
  ElMessageBox.prompt('请输入期次', '提示').then(({ value }) => {
    return createApi({
      createVos: selectionRows.value.map((e: any) => ({
        invoiceCompany: e.invoiceCompany,
        currency: e.currency,
        customerId: e.customerUsername
      })),
      range: {
        from: MI_params.dateRange.from,
        to: MI_params.dateRange.to,
        empty: false,
        notEmpty: false,
      },
      period: value,
    })
  }).then(() => {
    MI_identify.value = false
    ElMessage.success('创建成功')
    searchHandle()
  }).catch(() => {
    MI_identify.value = false
  })
  return


  MI_identify.value = true
  createApi({
    createVos: selectionRows.value.map((e: any) => ({
      invoiceCompany: e.invoiceCompany,
      currency: e.currency,
      customerId: e.customerUsername
    })),
    range: {
      from: MI_params.dateRange.from,
      to: MI_params.dateRange.to,
      empty: false,
      notEmpty: false,
    }
  }).then(() => {
    MI_identify.value = false
    ElMessage.success('创建成功')
    searchHandle()
  }).catch(() => {
    MI_identify.value = false
  })
}
// 生成数据报表
const reportFg=ref(false)
const reportData=ref([])
const creatReport_loading=ref(false)
const createReport=()=>{
  let {companyAlias,month}=searchObj
  let params={
    dateRange:{
      from:dayjs(month[0]).format("YYYY-MM-DD"),
      to:dayjs(month[1]).format("YYYY-MM-DD")
    },
    companyName:companyAlias
  }
  creatReport_loading.value=true
  exportReportApi(params).then((res:any)=>{
    reportData.value=res
    reportFg.value=true
    creatReport_loading.value=false
  }).catch(()=>{
    creatReport_loading.value=false
  })
}
const getRowKey=(row:any)=>{
  return row.company?""+row.company+row.currency:""+row.currency
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "应收账款" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "adjustRef",
              ref: adjustRef,
              model: _unref(searchObj),
              class: "searchBg",
              inline: "",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "类型：",
                  prop: "type"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).type,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).type) = $event)),
                      placeholder: "请选择类型"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "按月份",
                          value: "month"
                        }),
                        _createVNode(_component_el_option, {
                          label: "按季度",
                          value: "quarter"
                        }),
                        _createVNode(_component_el_option, {
                          label: "按年份",
                          value: "year"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司：",
                  prop: "companyAlias"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).companyAlias,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).companyAlias) = $event)),
                      placeholder: "请选择公司",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "深圳市昆仲科技有限公司",
                          value: "CCJK Technologies Co., Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "CCJK CO LIMITED",
                          value: "CCJK CO.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "CCJK LOCALIZATION PTE LTD",
                          value: "CCJK Localization Pte Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "深圳市比邻火星翻译有限公司",
                          value: "Mars Translation CO.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "湖南雅言翻译服务有限公司",
                          value: "Hunan Artlangs Translation Services Co.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "深圳市多语新媒体科技有限公司",
                          value: "Shenzhen Sodoglobal CO.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "武汉传禧文化有限公司",
                          value: "Wuhan Transee Translation Co., Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "长沙维译数字科技有限公司",
                          value: "WetransTech Media Solutions Co.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "深圳市火星众包科技有限公司",
                          value: "MarsCrowd CO.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "南昌顺飞数字翻译有限公司",
                          value: "LocalizationLine Solutions Co.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "长沙彼岸信息科技有限公司",
                          value: "Changsha BiAn language services co.,ltd"
                        }),
                        _createVNode(_component_el_option, {
                          label: "火星语盟（深圳）科技有限公司",
                          value: "Marshub Co.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "长沙彼岸译云医学科技有限公司",
                          value: "Changsha Beyond Cloud Translation Co.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "佛山市得译信息科技有限公司",
                          value: "Wordspath Information Co.,Ltd."
                        }),
                        _createVNode(_component_el_option, {
                          label: "火星语盟（湖南）科技有限公司",
                          value: "MarsHub(Hunan) Co., Ltd"
                        }),
                        _createVNode(_component_el_option, {
                          label: "火星语盟（湖南）科技有限公司",
                          value: "火星语盟（湖南）科技有限公司"
                        }),
                        _createVNode(_component_el_option, {
                          label: "MARS TRANSLATION HK CO LTD",
                          value: "Mars Translation HK CO.,Ltd."
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户名称：",
                  prop: "customerName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入客户名称",
                      modelValue: _unref(searchObj).customerName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).customerName) = $event)),
                      class: "form-input",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户ID：",
                  prop: "customerUsername"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入客户ID",
                      modelValue: _unref(searchObj).customerUsername,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).customerUsername) = $event)),
                      class: "form-input",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "邮件：",
                  prop: "email"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      placeholder: "请输入邮件",
                      modelValue: _unref(searchObj).email,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).email) = $event)),
                      class: "form-input",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "时间：",
                  prop: "date"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      type: "monthrange",
                      modelValue: _unref(searchObj).month,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).month) = $event)),
                      "value-format": "YYYY-MM-DD",
                      "unlink-panels": "",
                      "start-placeholder": "开始时间",
                      "range-separator": "至",
                      "end-placeholder": "结束时间",
                      clearable: false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "是否更新：",
                  prop: "update"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).update,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).update) = $event)),
                      placeholder: "请选择类型",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "是",
                          value: true
                        }),
                        _createVNode(_component_el_option, {
                          label: "否",
                          value: false
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "showZeroAmount" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _unref(searchObj).showZeroAmount,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchObj).showZeroAmount) = $event)),
                      label: "不显示发生额和余额为0",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "showClientMultiple" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _unref(searchObj).showClientMultiple,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchObj).showClientMultiple) = $event)),
                      label: "显示客户ID存在多行",
                      size: "large"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (adjustRef.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_4,
    _createVNode(_component_el_tooltip, {
      effect: "dark",
      content: "请先搜索后再导出",
      placement: "top-end"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(eptBtn, {
          exportFn: _unref(annual_statisticsExportApi),
          exportText: '导出',
          exportParam: _unref(MI_params)
        }, null, 8, ["exportFn", "exportParam"]), [
          [_directive_permission, 'Export']
        ])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_TheUpBtn, {
      class: "ml-10",
      upText: '导入应收账款',
      upFetch: _unref(batch_updateApi),
      upParams: {},
      showBtn: true
    }, null, 8, ["upFetch"]), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      disabled: _unref(MI_identify),
      type: "primary",
      plain: "",
      onClick: _cache[11] || (_cache[11] = ($event: any) => (createConfirmationHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Create']
    ]),
    _createVNode(_component_el_button, {
      disabled: _unref(MI_identify),
      onClick: createReport,
      loading: creatReport_loading.value
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["disabled", "loading"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      class: "mt-10",
      data: _unref(tableData),
      "max-height": _unref(MI_height) + 'px',
      onSelectionChange: _cache[12] || (_cache[12] = (rows) => _isRef(selectionRows) //@ts-ignore
 ? selectionRows.value = rows : selectionRows = rows)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          label: "客户ID",
          prop: "customerUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户名称",
          prop: "customerName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "开票主体",
          prop: "company",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          "show-overflow-tooltip": ""
        }),
        (_unref(searchObj).month && _unref(searchObj).month.length !== 0)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              width: "120",
              align: "right",
              label: _unref(previousTime).label,
              prop: "initAmount",
              formatter: _unref(formatNumber)
            }, null, 8, ["label", "formatter"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnsDays), (_time, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            label: _time.label,
            align: "center",
            key: _time.label
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "110",
                label: "提供订单",
                prop: "addAmount",
                align: "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("span", {
                    class: "numbClick",
                    onClick: ($event: any) => (showOrderList(row, _time, 'addIds'))
                  }, _toDisplayString(formatDataAmount(row, _time, {property: 'addAmount'})), 9, _hoisted_7)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                width: "110",
                label: "营收",
                prop: "orderAmount",
                align: "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("span", {
                    class: "numbClick",
                    onClick: ($event: any) => (showOrderList(row, _time, 'orderIds'))
                  }, _toDisplayString(formatDataAmount(row, _time, {property: 'orderAmount'})), 9, _hoisted_8)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                width: "110",
                label: "发票",
                prop: "invoiceAmount",
                align: "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("span", {
                    class: "numbClick",
                    onClick: ($event: any) => (showInvoiceList(row, _time))
                  }, _toDisplayString(formatDataAmount(row, _time, {property: 'invoiceAmount'})), 9, _hoisted_9)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                width: "110",
                label: "收款",
                prop: "paymentAmount",
                align: "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("span", {
                    class: "numbClick",
                    onClick: ($event: any) => (showFlowList(row, _time))
                  }, _toDisplayString(formatDataAmount(row, _time, {property: 'paymentAmount'})), 9, _hoisted_10)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_table_column, {
                align: "right",
                prop: "_lastVal",
                width: "110",
                label: _time.subTitle,
                formatter: (row, column, cellValue, _index) => formatDataAmount(row, _time, column)
              }, null, 8, ["label", "formatter"]),
              _createVNode(_component_el_table_column, {
                width: "110",
                label: "未确认订单",
                prop: "unconfirmedAmount",
                align: "right"
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("span", {
                    class: "numbClick",
                    onClick: ($event: any) => (showOrderList(row, _time, 'unconfirmedIds'))
                  }, _toDisplayString(formatDataAmount(row, _time, {property: 'unconfirmedAmount'})), 9, _hoisted_11)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[14] || (_cache[14] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [10, 30, 50, 200, 500, 1000],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: sizeChange
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange"]),
    _createVNode(_component_el_dialog, {
      width: "80%",
      top: "30px",
      modelValue: orderFg.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((orderFg).value = $event)),
      title: "订单详情"
    }, {
      default: _withCtx(() => [
        (orderFg.value)
          ? (_openBlock(), _createBlock(orderList, {
              key: 0,
              params: _unref(orderParams)
            }, null, 8, ["params"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "80%",
      top: "30px",
      modelValue: invoiceFg.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((invoiceFg).value = $event)),
      title: "发票详情"
    }, {
      default: _withCtx(() => [
        (invoiceFg.value)
          ? (_openBlock(), _createBlock(invoiceList, {
              key: 0,
              params: _unref(invoiceParams)
            }, null, 8, ["params"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "80%",
      top: "30px",
      modelValue: FlowFg.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((FlowFg).value = $event)),
      title: "流水详情"
    }, {
      default: _withCtx(() => [
        (FlowFg.value)
          ? (_openBlock(), _createBlock(flowList, {
              key: 0,
              params: _unref(FlowParams)
            }, null, 8, ["params"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "60%",
      top: "50px",
      modelValue: reportFg.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((reportFg).value = $event)),
      title: "数据报表"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          "max-height": "500px",
          "row-key": getRowKey,
          data: reportData.value,
          border: "",
          "tree-props": {children:'currencyList'}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "公司",
              prop: "company",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "币种",
              prop: "currency"
            }),
            _createVNode(_component_el_table_column, {
              label: "营收",
              prop: "orderAmount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "收款",
              prop: "paymentAmount",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: _unref(dayjs)(_unref(searchObj).month[1]).endOf("month").format("YYYY-MM-DD"),
              prop: "sum",
              align: "right",
              formatter: _unref(formatNumber)
            }, null, 8, ["label", "formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      width: "80%",
      top: "30px",
      modelValue: FlowFg.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((FlowFg).value = $event)),
      title: "流水详情"
    }, {
      default: _withCtx(() => [
        (FlowFg.value)
          ? (_openBlock(), _createBlock(flowList, {
              key: 0,
              params: _unref(FlowParams)
            }, null, 8, ["params"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})